export default {
  // 模式
  "common.mode.auto": "Pašizgūta un pašizmantota enerģija",
  "common.mode.economy": "Ekonomiskais režīms",
  "common.mode.exigency": "Neparedzētā situācijā režīms",

  // 设备
  "common.grid": "Elektro tīkls",
  "common.evChargers": "Izlādētāji elektriskajiem automobiļiem",
  "common.evCharger": "Izlādētājs elektriskajam automobiļam",
  "common.pv": "Fotovoltaika",
  "common.inverter": "Invertors",
  "common.pcs": "Invertors + baterija",
  "common.terminal": "Terminala ierīce",
  "common.airc": "Klimatizācijas ierīce",
  "common.engine": "Dzinātājs",
  "common.battery": "Baterija",
  "common.metter": "Elektromērs",
  "common.other": "Citi",
  "common.power": "Jauda",
  "common.powerTotal": "Kopējā jauda",
  "common.voltage": "Spriegums",
  "common.electricity": "Elektroenerģija",
  "common.current": "Strāva",
  "common.homeUsage": "Kopējā mājas ielādē",
  "common.battery.power": "Baterijas jauda",

  // 数据
  "common.noDataAvailable": "Pašlaik dati nav pieejami~",
  "common.tips": "Paziņojums",
  "common.reset": "Atjaunot",
  "common.currencyUnit": "¥",
  "common.submiting": "Apstiprina... Lūdzu, pagaidi...",
  "common.close": "Aizvērt",
  "common.from": "No",
  "common.useIn": "Izmantot",
  "common.energyPercent": "Enerģijas plūsmas procents",
  "common.dataFlow": "Datu plūsma",
  "common.getDataIng": "Iegūst dati... Lūdzu, pagaidi...",
  "common.pageLoading": "Lapas saturs ielādē... Lūdzu, pagaidi...",
  "common.reseting": "Lapas saturs atjaunojas... Lūdzu, pagaidi...",
  "common.save": "Saglabāt",
  "common.onlyNumberTips": "Var ievadīt tikai ciparus",
  "common.offline": "Bez interneta",
  "common.online": "Ar internetu",
  "common.fault": "Kļūda",
  "common.charge": "Izlādēt",
  "common.discharge": "Atlaist",
  "common.buy": "Iepirkt",
  "common.sell": "Iepardot",
  "common.loadingInfo": "Ielādē... Lūdzu, pagaidi...",

  // 
  "common.moreFeatures": "Vairāk funkciju",
  "common.confirm": "Apstiprināt",
  "common.saveing": "Saglabā... Lūdzu, pagaidi...",
  "common.searchPlacholder": "Ievadiet meklēšanas atslēgasvārdu",
  "common.iSee": "Es saprotu",
  "common.pageErrorTips1": "Oh, lapā ir kļūda~",
  "common.pageErrorTips2": "Mēģiniet atjaunot lapu vai sazināties ar atbalstu~",
  "common.refresh": "Atjaunot",
  "common.backToHome": "Atgriezties uz sākumlapu",
  "common.checkTips": "Pārbauda... Lūdzu, pagaidi...",
  "common.back": "Atgriezties",
  "common.cancel": "Atcelt",
  "common.optional": "Izvēles",
  "common.required": "Obligāts",
  "common.status": "Statuss",
  "common.statusNoDelete": "Nav dzēsts",
  "common.statusDelete": "Dzēsts",
  "common.submit": "Apstiprināt",
  "common.disable": "Deaktivizēt",
  "common.enable": "Aktivizēt",
  "common.year": "gads",
  "common.month": "mēnesis",
  "common.day": "diena",
  "common.version": "Versija:",
  "common.backHome": " Atgriezties uz sākumlapu",
  "common.backHomeSorry": " Atvainojiet, lapa nejauši zaudēja ceļu",
  "common.requestTips1": "Dati apstrādājas, lūdzu, neapstipriniet vēlreiz",
  "common.requestTips2": "Sistēmas paziņojums",
  "common.requestTips3": "Pieslēgšanās statuss ir beidzies, lūdzu, pieslēdzieties vēlreiz",
  "common.requestTips4": "Pieslēgties vēlreiz",
  "common.requestTips5": "Nederīga sesija vai sesija ir beidzies, lūdzu, pieslēdzieties vēlreiz.",
  "common.requestTips6": "Servera kļūda, lūdzu mēģiniet vēlāk.",
  "common.requestTips7": "Sistēmas interfeisa pieprasījuma laiks ir beidzies",
  "common.requestTips8": "Sistēmas interfeiss",
  "common.requestTips9": "Kļūda",
  "common.iknow": "Es saprotu",
  "common.logoutSuccess": "Izslēgšanās veiksmīga",
  
  // 了解更多组件
  "common.knowMore.title": "Ja vēlaties uzzināt vairāk, sazinieties ar Beineng",
  "common.knowMore.email": "Kontaktēšanās e-pasts",
  "common.knowMore.phone": "Kontaktēšanās tālrunis",
  "common.knowMore.wechat": "Kontaktēšanās WeChat",
  "common.knowMore.website": "Oficiālās tīmekļa vietnes adrese",
  "common.knowMore.address": "Kontaktēšanās adrese",
  "common.knowMore.addressDetail": "1205. un 1301. istabas, 5. māja, Qinghe iela 8, Huangjingkeng, Huangjiang novads, Dongguan pilsēta, Gvanguang provincija",
  
  // 本地连接组件
  "common.localConnection": "Lokālā savienojums",
  "common.operateInApp": "Darbini aplikācijā!",
  
  "common.enbleStaus": "Aktivizācijas statuss",
  "common.battery.status": "Bez izlādes un atlaišanas",

  "account.forgetThePassword": "Aizmirsi paroli",
  "account.logInDirectly": "Ienāc tieši",
  "account.tips1": "Lapa pārvietojas... Lūdzu, pagaidi...",
  "account.tips2": "Pirms visiem lasiet un pieņemt lietotāja noteikumus!",
  "account.autoLogin": "Automātiskā pieslēgšanās",
  "account.userLogin": "Lietotāja pieslēgšanās",
  "account.registerTips": "Vēl nav konta? Klikšķini šeit, lai reģistrētos",
  "account.userEmail": "Lietotājvārds / e-pasts",
  "account.userEmailTips": "Ievadiet lietotājvārdu vai e-pastu",
  "account.password": "Parole",
  "account.passwordTips": "Ievadiet paroli",
  "account.submit": "Apstiprināt",
  "account.submitTips": "Apstiprina... Lūdzu, pagaidi...",
  "account.otherLoginTips": "Vai izvēlieties citu pieslēgšanās veidu",
  "account.userRegistration": "Lietotāja reģistrācija",
  "account.userName": "Lietotājvārds",
  "account.userNameTips": "Ievadiet lietotājvārdu",
  "account.emailTips1": "Ievadiet e-pasta adresi",
  "account.emailTips2": "Nederīga e-pasta adrese formāts",
  "account.phone": "Tālrunis",
  "account.phoneTips1": "Ievadiet tālruņa numuru",
  "account.phoneTips2": "Nederīgs tālruņa numurs",
  "account.phoneTips3": "Ievadiet tālruņa numuru",
  "account.passwordTips1": "Ievadiet paroli (6-30 simboli)",
  "account.passwordTips2": "Nederīga parole formāts: parolei jābūt sastāvētai no angļu burtiem, cipariem, apakšsvītrām, domuzīmēm un punktiem, garums 6-12 simboli",
  "account.passwordTips3": "Divas ievadītās paroles nesakrīt, pārbaudiet un ievadiet vēlreiz!",
  "account.passwordTips4": "Ievadiet paroli: parolei jābūt sastāvētai no angļu burtiem, cipariem, apakšsvītrām, domuzīmēm un punktiem",
  "account.passwordTips5": "Paroles apstiprinājums",
  "account.passwordTips6": "Ievadiet paroles apstiprinājumu",
  "account.passwordTips7": "Divas ievadītās paroles nesakrīt, pārbaudiet un ievadiet vēlreiz!",
  "account.passwordTips8": "Ievadiet paroles apstiprinājumu",
  "account.passwordTips9": "Sveicināti, reģistrācija veiksmīga!",
  "account.passwordTips10": "Jūsu lietotājvārds ir:",
  "account.emailIs": "E-pasts ir:",
  "account.goToLoginPage": "Pēc s sekundēm automātiski pārvietosieties uz pieslēgšanās lapu",
  "account.goLogin": "Ienāc",
  "account.goRegister": "Reģistrējies",
  "account.loginSuccess": "Pieslēgšanās veiksmīga",
  "account.email": "E-pasts",
  "account.sologn": "Izveidojam individualizētu enerģijas risinājumu jums",
  "account.pleaseAgree": "Es esmu lasījis un pieņēmis",
  "userAgreement.privacyPolicy": "privātuma politiku",

  "account.code": "Verifikācijas kods",
  "account.codeTips": "Ievadiet verifikācijas kodu",
  "account.codeTips2": "Nederīgs verifikācijas kods",

    "account.inviteCodeTips": "Lūdzu, ievadiet uzaicinājuma kodu",
    "account.inviteCodeHint": "Lai iegūtu uzaicinājuma kodu, lūdzu, sazinieties ar uzstādītāju vai apkopes personālu",
  "account.modifyPasswordByAccount": "Paroles maiņa pēc konta",
  "account.modifyPasswordByEmail": "Paroles maiņa pēc e-pasta",
  "account.getPasswordByAccount": "Paroles atjaunošana pēc konta",
  "account.getPasswordByEmail": "Paroles atjaunošana pēc e-pasta",

  "account.sendEmailTips": "Verifikācijas kods nosūtīts uz e-pastu, pārbaudiet to",
  "account.name": "Konta nosaukums",
  "account.newPassword": "Jauna parole",
  "account.confirmNewPassword": "Jaunas paroles apstiprinājums",
  "account.nameTips": "Ievadiet konta nosaukumu",
  "account.passwordModifySuccess": "Paroles maiņa veiksmīga",
  "account.emailCode": "E-pasta verifikācijas kods",
  "account.emailCodeTips": "Ievadiet e-pasta verifikācijas kodu",
  "account.emailCodeTips2": "Nederīgs e-pasta verifikācijas kods",
  "account.emailModifySuccess": "Paroles maiņa veiksmīga",
  "account.passworTips1": "Jūsu parole veiksmīgi atjaunota!",
  "account.passwordTips11": "Ievadiet paroles apstiprinājumu",
  "account.passwordTips12": "Ievadiet jauno paroli",
  "account.nickname": "Lietotāja vārds",
  "account.modifyNickname": "Lietotāja vārda maiņa",
  "account.modifyNicknameSuccess": "Lietotāja vārda maiņa veiksmīga!",
  "account.nicknameTips": "Ievadiet lietotāja vārdu",
  "account.nicknameError": "Lietotāja vārda maiņa neveiksmīga!",

  "account.login": "Ienāc",
  "account.quickRegister": "Ātra reģistrācija",
  "account.sendCode": "Sūtīt kodu",
  "account.sendTips": "Pēc s sekundēm varat sūtīt vēlreiz",
  "account.sendEmailIng": "Sūta e-pastu... Lūdzu, pagaidi...",
  "account.emailNotEmpty": "E-pasta adrese nevar būt tukša",
  "account.registerAccount": "Reģistrēt kontu",
  "account.registerWelcome": "Laipni lūdzam SusprSafe reģistrācijā",
  "account.usernameLimit": "Lietotājvārdam jā sākas ar burtu un var saturēt tikai burtus, ciparus un apakšsvītras, garums 5-15 simboli",

  "copyright.desc2": "Tīmekļa vietnes reģistrācijas informācija: Gvanguang ICP reģistrācija nr. 2021169764",

  "editUserInfo.editUserInformation": "Lietotāja informācijas rediģēšana",
  "editUserInfo.modifyUsername": "Lietotājvārda maiņa",
  "editUserInfo.changePictures": "Profila attēla maiņa",
  "editUserInfo.savePicturesSuccess": "Lietotāja profila attēls veiksmīgi saglabāts",
  "editUserInfo.saveError": "Saglabāšana neveiksmīga",
  "editUserInfo.pictureLimit": "Attēlam jābūt mazākam par 2 MB",
  "editUserInfo.uploadPicture": "Ielādēt profila attēlu",
  "editUserInfo.picturePreview": "Priekšskats",
  
  "editUserInfo.bindPhoneNumber": "Tālruņa numura savienošana",
  "editUserInfo.bindEmail": "E-pasta savienošana",
  "editUserInfo.changePassword": "Paroles maiņa",

  "editUserInfo.notificationSettings": "Paziņojumu iestatījumi",
  "editUserInfo.editAccount": "Lietotāja konta informācijas rediģēšana",
  "editUserInfo.waitBingting": "Savienojas... Lūdzu, pagaidi...",
  "editUserInfo.collapse": "Saspiest",
  "editUserInfo.modifyBinding": "Savienojuma maiņa",
  
  "editUserInfo.emailAddress": "E-pasta adrese",
  "editUserInfo.tips1": "E-pasta savienošana veiksmīga",
  "editUserInfo.tips2": "Saglabāšana neveiksmīga",
  "editUserInfo.tips3": "Sūta e-pasta verifikācijas kodu... Lūdzu, pagaidi...",
  "editUserInfo.tips4": "Verifikācijas kods nosūtīts uz xxxx e-pastu, pārbaudiet to",
  "editUserInfo.tips5": "Verifikācijas koda sūtīšana neveiksmīga!",
  "editUserInfo.tips6": "Tālruņa numurs jau ir savienots",
  "editUserInfo.tips7": "E-pasts jau ir savienots",
  "editUserInfo.emailTips1": "Ievadiet e-pasta adresi",
  "editUserInfo.emailTips2": "Nederīga e-pasta adrese formāts",
  "editUserInfo.emailTips3": "Pēc xxxx sekundēm varat sūtīt vēlreiz",
  "editUserInfo.emailTips4": "Sūtīt kodu",
  "editUserInfo.emailTips5": "E-pasta verifikācijas kods nevar būt tukšs",
  "editUserInfo.emailTips6": "Nederīgs e-pasta verifikācijas kods",
  "editUserInfo.emailCode": "E-pasta verifikācijas kods",
  "editUserInfo.save": "Saglabāt",

  "editUserInfo.phoneTips1": "Tālruņa numura savienošana veiksmīga",
  "editUserInfo.phoneTips2": "Sūta SMS verifikācijas kodu... Lūdzu, pagaidi...",
  "editUserInfo.phoneTips3": "SMS verifikācijas kods nosūtīts uz xxxx tālruņa numuru, pārbaudiet to",
  "editUserInfo.phoneTips4": "SMS verifikācijas koda sūtīšana neveiksmīga!",
  "editUserInfo.phoneTips5": "Ievadiet tālruņa numuru",
  "editUserInfo.phoneTips6": "Nederīgs tālruņa numura formāts",
  "editUserInfo.phoneTips7": "Sūtīt SMS verifikācijas kodu",
  "editUserInfo.phoneTips8": "SMS verifikācijas kods",
  "editUserInfo.phoneTips9": "SMS verifikācijas kods nevar būt tukšs",
  "editUserInfo.phoneTips10": "Nederīgs SMS verifikācijas kods",
  "editUserInfo.phone": "Tālruņa numurs",


  "editUserInfo.noticeTips1": "Paziņojumu iestatījumu iegūšana neveiksmīga!",
  "editUserInfo.noticeTips2": "Paziņojumu iestatījumi veiksmīgi saglabāti!",
  "editUserInfo.noticeTips3": "Paziņojums par zemu baterijas līmeni",
  "editUserInfo.noticeTips4": "Paziņojums par izlādes pabeigšanos izlādētāja",
  "editUserInfo.errorNotification": "Kļūdas paziņojums",
  "editUserInfo.updateNotification": "Atjauninājuma paziņojums",
  "editUserInfo.monthlyStatisticsNotification": "Mēneša statistikas paziņojums",
  "editUserInfo.notificationMethod": "Saņemšanas veids",

  "editUserInfo.userNameTips1": "Lietotājvārds veiksmīgi saglabāts",
  "editUserInfo.userNameTips2": "Lietotājvārda saglabāšana neveiksmīga",
  "editUserInfo.userNameTips3": "Ievadiet lietotājvārdu",
  "editUserInfo.userNameTips4": "Nederīgs lietotājvārda formāts: jābūt sastāvētam no cipariem, apakšsvītrām un angļu burtiem",
  "editUserInfo.userNameTips5": "Ievadiet lietotājvārdu",
  "editUserInfo.userNameTips6": "Saglabā... Lūdzu, pagaidi...",
  "editUserInfo.userName": "Lietotājvārds",

  "editUserInfo.avatorTips": "Klikšķini, lai mainītu profila attēlu",
  "editUserInfo.verifyCodeTips1": "Ievadiet saņemto verifikācijas kodu:",
  "editUserInfo.verifyCodeTips2": "Konta drošības labad klikšķini uz leņķa pogas, lai sūtītu verifikācijas kodu uz oriģināla tālruņa numuru:",
  "editUserInfo.verifyCodeTips3": "Sūtīt kodu",
  "editUserInfo.verifyCodeTips4": "Oriģināla tālruņa verifikācija veiksmīga, ievadiet jauno savienoto tālruņa numuru",
  "editUserInfo.verifyCodeTips5": "Konta drošības labad klikšķini uz leņķa pogas, lai sūtītu verifikācijas kodu uz oriģināla e-pastu:",
  "editUserInfo.verifyCodeTips6": "Oriģināla e-pasta verifikācija veiksmīga, ievadiet jauno e-pastu",
  "editUserInfo.verifyCodeTips7": "Vecā parole",
  "editUserInfo.verifyCodeTips8": "Pirms visiem savienojiet e-pastu!",
  "editUserInfo.verifyCodeTips9": "Verifikācijas kods nosūtīts uz e-pastu, pārbaudiet to",
  "editUserInfo.verifyCodeTips10": ", automātiski pārvietosieties uz pieslēgšanās lapu",

  "hems.notice.title": "Paziņojuma virsraksts", 
  "hems.notice.content": "Paziņojuma saturs", 
  "hems.notice.operate": "Darbība",
  "hems.notice.noRead": "Nelasīts",
  "hems.notice.read": "Lasīts",
  "hems.notice.warning": "Brīdinājums",
  "hems.notice.error": "Kļūda",
  "hems.notice.success": "Statistikas atlīdzīšana",
  "hems.notice.sys": "Sistēmas informācija",
  "hems.notice.operateSuccess": "Darbība veiksmīga",
  "hems.notice.operateTips": "Izvēlieties darbībai必要的 elementu",

  // 首页
  "hems.home.selfuseRate": "Pašizgūtas un pašizmantotas enerģijas procents",
  "hems.home.percent": "Procents",
  "hems.home.todayData": "Šodienas dati",
  "hems.home.todayPowerGeneration": "Šodienas enerģijas ražošana",
  "hems.home.salesIncome": "Enerģijas pārdošanas ienākumi",
  "hems.home.saved": "Jūs esat ietaupījis",
  "hems.home.reduce": "Samazināt oglekļa pēdas",
  "hems.home.tips1": "Pašlaik dati nav pieejami, jūs vēl neesat savienojis xxxx",
  "hems.home.criticalLoad": "Kritiskā ielāde",
  "hems.home.keyVoltage": "Kritiskais spriegums",
  "hems.home.householdLoad": "Mājas ielāde",
  "hems.home.householdVoltage": "Mājas spriegums",
  "hems.home.generalLoad": "Parastā ielāde",
  "hems.home.generalVoltage": "Parastais spriegums",
  "hems.home.batteryHealth": "Baterijas veselība",
  "hems.home.averageTemp": "Vidējā temperatūra",
  "hems.home.gridLoad": "Elektro tīkla ielāde",
  "hems.home.toggeleDataSource": "Pašlaik parādītie dati ir pārvietoti uz:",
  "hems.home.toggleTips": "Vai jūs esat pārliecināti, ka vēlaties mainīt?",
  "hems.home.modeSending": "Režīma komanda sūtīta... Lūdzu, pagaidi...",
  "hems.home.modeSuccess": "Režīma pārliekšanas komanda veiksmīgi nosūtīta!",
  "hems.home.isOnline": "Vai ar internetu?",
  "hems.home.useStatus": "Izmantotā statuss",
  "hems.home.workModeText": "Pašlaik darbības režīms:",
  "hems.home.toggleDataSourceText": "Pašlaik parādītie dati ir pārvietoti uz:",
  "hems.ev.charge.status": "Izlādes statuss",
  "hems.ev.charge.time": "Izlādes laiks",
  "hems.ev.charge.count": "Reāllaika izlādētā enerģija",
  "hems.ev.charge.status.empty": "Brīvs",
  "hems.ev.charge.status.ing": "Izlādē ar pieslēgtu kabeli",
  "hems.ev.charge.status.null": "Kabels pieslēgts, bet bez izlādes",
  "hems.ev.charge.status.error": "Kļūda",
  "hems.hour": "stunda",
  "hems.minue": "minūte",
  "hems.ev.chagre.number": "Izlādētāja numurs",

  // User Guide
  "hems.userGuide.selfUse": "Pašizgūta un pašizmantota enerģija",
  "hems.userGuide.selfUseTips": "Prioritāti dodiet fotovoltaiskajai enerģijai, ja nav pietiekami, papildiniet no elektro tīkla",
  "hems.userGuide.economyMode": "Ekonomiskais režīms",
  "hems.userGuide.economyModeTips": "Optimizēt enerģijas izmantošanas stratēģiju pēc elektroenerģijas cenas",
  "hems.userGuide.emergencyMode": "Neparedzētā situācijā režīms",
  "hems.userGuide.emergencyModeTips": "Prioritāti dodiet kritiskās ielādes enerģijas nodrošināšanai",

  // 图表页面
  "hems.history.energyStatistics": "Enerģijas statistika",
  "hems.history.revenueStatistics": "Ienākumu statistika",
  "hems.history.greenStatistics": "Zaļā emisiju samazināšana",
  "hems.history.revenueTitle": "Kopējie ienākumi no enerģijas pārdošanas",
  "hems.history.savingsTitle": "Kopējie ietaupījumi",
  "hems.history.carbonTitle": "Kopējā oglekļa emisiju samazināšana",
  "hems.history.day": "diena",
  "hems.history.month": "mēnesis",
  "hems.history.year": "gads",
  "hems.history.beforeDay": "Iepriekšējā diena",
  "hems.history.afterDay": "Nākamā diena",
  "hems.history.beforeMonth": "Iepriekšējais mēnesis",
  "hems.history.afterMonth": "Nākamais mēnesis",
  "hems.history.beforeYear": "Iepriekšējais gads",
  "hems.history.afterYear": "Nākamais gads",
  "hems.history.totalUse": "Kopējā izmantošana",
  "hems.history.fullScreen": "Pilns ekrāns",
  "hems.history.timeSelect": "Datuma izvēle",
  "sync.tips1": "Datu sinhronizācijas komanda veiksmīgi nosūtīta!",
  "sync.tips2": "Datu sinhronizācija notiek,由于 datu daudzuma dēļ tā aizņems laiku, pārbaudiet vēlreiz pēc pusstundas~",
  "sync.tips3": "Ierīces datu sinhronizācijā var būt aizkavēšanās, ja atrodat datu neatbilstības, klikšķini uz:",
  "sync.tips4": "Sinhronizēt datus",

  "charge.info": "Izlādētāja informācija",
  "news.loading": "Ielādē...",
  "news.noMore": "Vairāk dati nav",
  "hems.pv.power": "Fotovoltaiskās enerģijas daudzums",

  // UEH specific
  "ueh.sellPower": "Pārdošanas enerģijas daudzums",
  
  "menu.home": "Sākumlapa",
  "menu.history": "Istoriskie dati",
  "menu.device": "Ierīces",
  "menu.settings": "Iestatījumi",
  "menu.messageCenter": "Ziņu centrs",
  "menu.help": "Palīdzība un atbalsts",
  "menu.mine": "Mani dati",


  "mine.userSetting": "Lietotāja iestatījumi",
  "mine.terminalSetting": "Terminala pamatiestatījumi",
  "mine.uploadCloud": "Datu saglabāšana mākonī",
  "mine.changeVersion": "Pārbaudīt atjauninājumus",
  "mine.language": "Mainīt valodu",
  "mine.about": "Par aplikāciju",
  "mine.feedback": "Atbalsts",
  "mine.logout": "Izslēgties",
  "mine.logoutAccount": "Dzēst kontu",

  "mine.logoutAccountTips": "Dzēst kontu ar nosaukumu []",
  "mine.logoutAccountTips1": "Dzēst kontu, kas savienots ar []",
  "mine.logoutAccountCare": "Kontu dzēšanas pieprasījuma atbilstošie punkti:",
  "mine.logoutAccountCare1": "1. Konts ir drošā stāvoklī",
  "mine.logoutAccountCare1-1": "Konts ir normālā izmantošanas stāvoklī, nav krāšanas, pārkāpumu vai bloķēšanas risku.",
  "mine.logoutAccountCare2": "2. Konta autorizācijas un savienojumi ir atcelti",
  "mine.logoutAccountCare2-1": "Visi konta autorizācijas ar citām trešās puses platformām ir atcelti.",
  "mine.logoutAccountCare3": "3. Pēc konta dzēšanas to nevar atjaunot, lietotāja dati tiks dzēsti",
  "mine.logoutAccountCare3-1": "Pēc konta dzēšanas savienotais tālruņa numurs, e-pasts un citi dati tiks dzēsti un nevar atjaunot.",
  "mine.confirmLogout": "Apstiprināt dzēšanu",
  "mine.logoutSuccess": "Konts veiksmīgi dzēsts!",


  "mine.feedbackIssues": "Problēmu atbalsts",
  "mine.feedQuantity": "Daudzums",
  "mine.feedAmount": "Maksimāli 9 attēli, maksimālā izmēra 1 MB/attēls",

  "mine.notice.fail": "Paziņojumu iestatījumu iegūšana neveiksmīga!",
  "mine.notice.saveSuccess": "Paziņojumu iestatījumi veiksmīgi saglabāti!",
  "mine.notice.saveFail": "Saglabāšana neveiksmīga!",
  "mine.notice.title": "Paziņojumu iestatījumi",
  "mine.notice.batteryLow": "Paziņojums par zemu baterijas līmeni",
  "mine.notice.chargingFinish": "Paziņojums par izlādes pabeigšanos izlādētāja",
  "mine.notice.error": "Kļūdas paziņojums",
  "mine.notice.update": "Atjauninājuma paziņojums",
  "mine.notice.monthly": "Mēneša statistikas paziņojums",
  "mine.notice.receiveType": "Saņemšanas veids",

  "mine.language.welcome": "Laipni lūdzam SusprSafe",
  "mine.language.desc1": "Izvēlieties valodas versiju pēc jūsu atrašanās vietas",
  "mine.language.desc2": "Jūs varat to mainīt jebkurā laikā aplikācijas iestatījumos",

  "mine.userInfo.avatar": "Profila attēls",
  "mine.userInfo.nickname": "Vārds",
  "mine.userInfo.password": "Parole",
  "mine.userInfo.changePassword": "Paroles maiņa",
  "mine.userInfo.setPassword": "Iestatīt paroli",
  "mine.userInfo.phoneNumber": "Tālruņa numurs",
  "mine.userInfo.bindPhone": "Tālruņa numura savienošana",
  "mine.userInfo.bindEmail": "E-pasta savienošana",
  "mine.loginExpired": "Pieslēgšanās statuss ir beidzies, lūdzu, pieslēdzieties vēlreiz",
  "mine.userInfo.title": "Lietotāja informācija",
  "mine.userInfo.bind": "Savienot",
  "mine.userInfo.modify": "Mainīt",
  "mine.userInfo.modifyNickname": "Vārda maiņa",
  "mine.userInfo.userNickname": "Lietotāja vārds",
  "mine.userInfo.selectPic": "Izvēlieties ielādējamo attēlu",
  "mine.userInfo.saveSuccess": "Saglabāšana veiksmīga",
  "mine.userInfo.uploadFail": "Ielāde neveiksmīga",
  "mine.userInfo.avatarSaveSuccess": "Profila attēls veiksmīgi saglabāts",
  "mine.userInfo.nameTips1": "Lietotāja vārds nevar būt tukšs",
  "mine.userInfo.nameTips2": "Ievadiet lietotāja vārdu",

  "common.pleaseSelect": "Lūdzu, izvēlieties",
  "question.commonQuestions": "Bieži jautātie jautājumi",
  "account.toggleLanguage": "Mainīt valodu",
  "account.localConnection": "Lokālā savienojums",
  "account.selectLanguage": "Lūdzu, izvēlieties valodu",
  "account.sendEmailToast": "Verifikācijas kods nosūtīts uz xxx e-pastu, pārbaudiet to",
  "account.emailError": "Nederīga e-pasta formāts",
  "account.sendEmailFail": "Sūtīšana neveiksmīga, mēģiniet vēlreiz",
  
  "common.submitting": "Apstiprina... Lūdzu, pagaidi...",

  "device.page.noData": "Pašlaik dati nav pieejami, šo lapu var apskatīt tikai aplikācijā"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};